const targets = document.querySelectorAll(".js-overlined")
const cssToggler = "is-ready"

const Overliner = {
	init: () => {
		if (!targets.length) return
		targets.forEach((target) => {
			Overliner.overline(target)
		})
	},

	/**
	 * Main function
	 * @param {HTMLElement} target main title tag (h1, h2...)
	 * @param {boolean} resized has the element's width been calculated already ?
	 */
	overline: (target) => {
		let firstLineWidth = Overliner.getFirstLine(target, true)
		if (typeof firstLineWidth === "number") {
			let overline = target.querySelector(".overline")
			if (overline) {
				overline.style.maxWidth = firstLineWidth + "px"
			}
			// Overliner.activate(target)
			target.classList.add(cssToggler)
		} else {
			console.error("Title overliner : 'firstLineWidth' is NaN.", firstLineWidth, target)
		}
	},

	/**
	 * DEPRECATED - Tentative de faire fonctionner les transitions CSS
	 * @param {HTMLElement} target
	 */
	activate: (target) => {
		if (target.classList.contains(cssToggler)) {
			target.classList.remove(cssToggler)
			target.classList.add(cssToggler)
		} else {
			target.classList.add(cssToggler)
		}
	},

	/**
	 *
	 * @param {HTMLElement} el Must wrap a string
	 * @param {boolean} getWidth return either first line as a string (default), or calculate its width
	 * @returns
	 */
	getFirstLine: (el, getWidth = false) => {
		const text = el.innerHTML
		let firstLineWidth = ""

		let totalElementHeight = el.offsetHeight
		//set the innerHTML to a character
		el.innerHTML = "A"
		//get the offsetheight of the single character
		const singleLineHeight = el.offsetHeight
		// if multiline
		if (totalElementHeight !== singleLineHeight) {
			//split all innerHTML on spaces
			let arr = text.split(" ")

			//cur is the current value of the text we are testing to see if
			//it exceeds the singleLineHeight when set as innerHTML
			//prev is the previously tested string that did not exceed the singleLineHeight
			//cur and prev start as empty strings
			let cur = ""
			let prev = ""

			//loop through, up to array length
			for (let i = 0; i < arr.length; i++) {
				//examine the rest of text that is not already in previous string
				let restOfText = text.substring(prev.length, text.length)

				//the next space that is not at index 0
				let nextIndex =
					restOfText.indexOf(" ") === 0 ? restOfText.substring(1, restOfText.length).indexOf(" ") + 1 : restOfText.indexOf(" ")
				if (nextIndex === 0) {
					nextIndex = restOfText.length
				}

				//the next part of the rest of the text
				cur += restOfText.substring(0, nextIndex)
				//set the innerHTML to the current text
				el.innerHTML = cur
				//now we can check its offsetHeight
				if (el.offsetHeight > singleLineHeight) {
					//once offsetHeight of cur exceeds singleLineHeight
					//previous is the first line of text
					//set innerHTML = prev so
					el.innerHTML = prev
					//we can grab the innertext
					let firstLine = el.innerText
					// If inline width is needed
					if (getWidth) {
						el.style.display = "inline"
						firstLineWidth = el.offsetWidth
						el.style.display = "block"
					}
					// let indexOfSecondLine = prev.lastIndexOf("<")

					//reset el
					el.innerHTML = text

					return getWidth ? firstLineWidth : firstLine
				}

				//offsetheight did not exceed singleLineHeight
				//so set previous = cur and loop again
				//prev = cur + ' ';
				prev += cur.substring(prev.length, cur.length)
			}
			// Title is one line only
		} else {
			//reset el
			el.innerHTML = text
			if (getWidth) {
				el.style.display = "inline"
				// get inline width
				firstLineWidth = el.offsetWidth
				el.style.display = "block"
			}

			return getWidth ? firstLineWidth : text
		}
	},
}

export default Overliner
